import { getTableHeaderData } from './table-mapping';

export function generateGoogleSheetsData(tableRows) {
  const tableHeaders = getTableHeaderData();
  const tableRowArrays = tableRows.map(tr => tableHeaders.map(th => tr[th]));
  return tableRowArrays;
}
